<template>
  <cg_mask class="confirm_container">
    <div class="main">
      <p class="title">
        <span>相关问题说明</span>
        <img class="close" @click="$emit('close')" src="../assets/image/close.png" />
      </p>
      <div class="faqlist">
        <div class="faqitem" v-for="(item, index) in faqlist" @click="openfaq(index)" :keys="index">
          <p class="que">
            <span>{{ item.que }}</span>
            <img :class="{ down: true, up: findex == index }" src="../assets/image/down.png" />
          </p>
          <div :class="{ answer: true, addheight: findex == index }" v-html="item.answer"></div>
        </div>
      </div>
    </div>
  </cg_mask>
</template>
<script>
export default {
  props: ['title'],
  data() {
    return {
      findex: 'a',
      faqlist: [
        {
          que: '未成年有充值额度限制吗？',
          answer:
            '<p >根据《国家新闻出版署关于防止未成年人沉迷网络游戏的通知》第三条规定：</p><p class="mt16">1、未满8周岁的用户不能充值。</p><p class="mt16">2、8周岁以上未满16周岁的用户，单次充值金额不得超过50元人民币，每月充值金额累计不得超过200元人民币。</p><p class="mt16">3、16周岁以上未满18周岁的用户，每次充值金额不得超过100元人民币，每月充值金额累计不得超过400元人民币。</p>',
        },
        {
          que: '支付宝支付有额度限制吗？',
          answer:
            '<p>根据您的支付方式不同，额度限制也会有所不同，详情如下：</p><p class="mt16">1、若您使用余额付款，具体额度是由支付场景和账户等级所决定，每年最高可累计支付20万元。</p><p class="mt16" >2、若您使用银行卡付款，具体额度与您的银行卡额度保持一致。</p><p class="mt16">3、若您使用余额宝付款，则没有额度限制。</p>',
        },
        {
          que: '遇到支付宝支付限额该怎么办？',
          answer:
            '<p>当您发现使用支付宝支付时遇到额度问题，推荐您优先用余额宝支付，或者更换银行卡支付。</p><p class="mt16">更多支付宝支付相关问题，可进入支付宝app-我的-右上角我的客服-搜索询问或联系在线客服，或直接与我们的客服联系，感谢您的理解！</p>',
        },
      ],
    }
  },
  methods: {
    openfaq(index) {
      if (this.findex == index) {
        this.findex = 'a'
      } else {
        this.findex = index
      }
    },
  },
}
</script>
<style scoped lang="less">
@import '../assets/css/zIndex.less';
.confirm_container {
  z-index: @confrim_modal;
  display: flex;
  align-items: center;
  justify-content: center;
  .main {
    width: 700px;
    max-height: 1000px;
    overflow: hidden;
    background: #fff;
    border-radius: 16px;
    text-align: center;
    position: relative;
    .title {
      font-size: 26px;
      color: #202226;
      font-weight: 400;
      line-height: 34px;
      font-family: Microsoft YaHei;
      padding: 22px 0 30px;
    }

    .close {
      position: absolute;
      width: 15px;
      height: 15px;
      right: 13px;
      top: 13px;
      cursor: pointer;
    }
  }

  .faqlist {
    height: 100%;
    overflow-y: auto;
    padding-bottom: 40px;
    overflow: hidden;
  }

  .faqitem {
    margin: 40px 30px 0;
    .que {
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 18px;
      color: #282828;
      line-height: 22px;
      display: flex;
      justify-content: space-between;
    }

    .down {
      height: 10px;
      cursor: pointer;
      transition: transform 0.5s ease;
    }
    .up {
      transform: rotate(180deg);
    }

    .answer {
      margin-top: 14px;
      background: #f4f7f8;
      border-radius: 10px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 17px;
      text-align: left;
      height: 0px;
      box-sizing: border-box;
      color: #767778;
      line-height: 23px;
      overflow: hidden;
      padding: 0px;
    }

    .addheight {
      height: auto;
      padding: 14px;
    }
  }
}

@media (max-width: 1024px) {
  .confirm_container {
    .main {
      width: calc(100vw - 0.4rem);
      max-height: 80vh;
      overflow: hidden;
      background: #fff;
      border-radius: 0.16rem;
      text-align: center;
      .title {
        font-size: 0.38rem;
        color: #202226;
        font-weight: 400;
        line-height: 0.48rem;
        font-family: Microsoft YaHei;
        padding: 0.3rem 0 0.4rem;
      }

      .close {
        position: absolute;
        width: 0.26rem;
        height: 0.26rem;
        right: 0.26rem;
        top: 0.26rem;
        cursor: pointer;
      }
    }

    .faqlist {
      height: 100%;
      overflow-y: auto;
      padding-bottom: 0.4rem;
      overflow: hidden;
    }

    .faqitem {
      margin: 0.4rem 0.3rem 0;

      .que {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 0.28rem;
        color: #282828;
        line-height: 0.32rem;
        display: flex;
        justify-content: space-between;
      }

      .down {
        height: 0.24rem;
        cursor: pointer;
        transition: transform 0.2s ease;
      }
      .up {
        transform: rotate(180deg);
      }

      .answer {
        margin-top: 0.2rem;
        background: #f4f7f8;
        border-radius: 10px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 0.24rem;
        text-align: left;
        height: 0px;
        box-sizing: border-box;
        color: #767778;
        line-height: 0.36rem;
        overflow: hidden;
        padding: 0px;
      }

      .addheight {
        height: auto;
        padding: 0.2rem;
      }
    }
  }
}
</style>
